import type { PeriodSummaryMode } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryMode.ts";
import type { PeriodSummaryRange } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryRange.ts";
import { getLastYearSameDay } from "@/shared/utils/Dates.ts";
import { DateTime } from "luxon";

interface DatesRange {
  start: Date;
  end: Date;
}

export default function computeSummaryDates(
  date: Date,
  mode: PeriodSummaryMode,
  range: PeriodSummaryRange,
): DatesRange | undefined {
  switch (mode) {
    case "FORECAST":
      return forecastRange(date, range);
    case "PREVIOUS_YEAR":
      return previousYearRange(date, range);
    case "TREND":
      return undefined;
  }
}

function forecastRange(
  date: Date,
  range: PeriodSummaryRange,
): DatesRange | undefined {
  switch (range) {
    case "DAY": {
      return { start: date, end: date };
    }
    case "MONTH": {
      return {
        start: date,
        end: DateTime.fromJSDate(date)
          .plus({ month: 1 })
          .minus({ day: 1 })
          .toJSDate(),
      };
    }
    case "WEEK": {
      return undefined;
    }
  }
}

function previousYearRange(
  date: Date,
  range: PeriodSummaryRange,
): DatesRange | undefined {
  switch (range) {
    case "DAY": {
      const d = getLastYearSameDay(date);
      return { start: d, end: d };
    }
    case "MONTH": {
      const lastYear = DateTime.fromJSDate(date).minus({ year: 1 });
      return {
        start: lastYear.toJSDate(),
        end: lastYear.plus({ month: 1 }).minus({ day: 1 }).toJSDate(),
      };
    }
    case "WEEK": {
      return undefined;
    }
  }
}
